import { connect } from 'react-redux'
import { useRef } from 'react'
import { isValidJSON } from 'Services/WeaverUtils'
import AceEditor from 'react-ace'
import 'ace-builds/webpack-resolver'
import 'ace-builds/src-noconflict/mode-html'
import "ace-builds/src-noconflict/mode-json5";
import 'ace-builds/src-noconflict/snippets/html'

JsonInput = ({ darkModeEnabled, extra, value, name, mode, ...props }) ->

  value = if typeof value is 'object'
    JSON.stringify(value, null, 2)
  else if isValidJSON(value)
    JSON.stringify(JSON.parse(value), null, 2)
  else
    value

  aceEditorRef = useRef(null);

  <div style={{ borderRadius: '10px', border: 'solid 1px #eee', padding: "2px"}}>
    { extra }
    <AceEditor
      {props...}
      name={name.join('-')}
      ref={aceEditorRef}
      value={value}
      style={{ width: '100%', borderRadius: 9 }}
      theme={darkModeEnabled && "solarized_dark" || "solarized_light"}
      showGutter={true}
      mode={mode || "json"}
      font={14}
      setOptions={{
        highlightActiveLine: false,
        highlightGutterLine: false,
        showLineNumbers: false,
        minLines: 5,
        maxLines: 1000,
        autoScrollEditorIntoView: false,
      }}
    />
  </div>

mapStateToProps = ({ explore }) -> {
  darkModeEnabled: explore.darkModeEnabled
}

export default connect(mapStateToProps)(JsonInput)
